"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledParagraph = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledParagraph = styled_components_1.default.p `
  color: ${config_1.colors.grayText};
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
`;
